import type { AreaCatalog } from '../area';
import type { mail as en } from '../en/mail';

export const mail = {
  'mail.ignore': 'Wenn du das nicht angefragt hast, kannst du diese E-Mail ignorieren.',
  'mail.underAccount': 'Gib ihn unter Konto ein: {url}',
  'mail.orOpen': 'Oder öffne: {url}',
  'mail.changeEmail.subject': 'Bestätige deine neue Tesserano-Adresse',
  'mail.changeEmail.code':
    'Jemand möchte ein Tesserano-Konto auf diese Adresse umstellen. Bestätige es mit diesem Code: {code}',
  'mail.signIn.subject': 'Dein Tesserano-Anmeldecode',
  'mail.signIn.codeOnly': 'Dein Tesserano-Anmeldecode: {code}',
  'mail.signIn.typeIt': 'Gib ihn auf der Anmeldeseite ein, die du offen hast.',
  'mail.signIn.code': 'Melde dich mit diesem Code bei Tesserano an: {code}',
  'mail.reset.subject': 'Setz dein Tesserano-Passwort zurück',
  'mail.reset.code': 'Setz dein Tesserano-Passwort mit diesem Code zurück: {code}',
  'mail.verify.subject': 'Bestätige deine Tesserano-E-Mail-Adresse',
  'mail.verify.code': 'Bestätige deine Tesserano-E-Mail-Adresse mit diesem Code: {code}',
  'mail.approve.subject': 'Erlaube den Umzug deines Tesserano-Kontos',
  'mail.approve.code':
    'Jemand möchte dieses Tesserano-Konto auf {email} umstellen. Erlaube es mit diesem Code: {code}',
  'mail.approve.ignore':
    'Wenn du das nicht angefragt hast, ignoriere diese E-Mail und ändere dein Passwort.',
  'mail.invite.subject': 'Du wurdest zu Tesserano eingeladen',
  'mail.invite.intro': 'Du wurdest eingeladen, bei Tesserano mitzuarbeiten.',
  'mail.invite.open': 'Öffne deine Einladung: {url}',
  'mail.invite.accept':
    'Melde dich mit dieser E-Mail-Adresse an oder erstelle ein kostenloses Konto, um anzunehmen. Dieser Link läuft in 14 Tagen ab.',
} as const satisfies AreaCatalog<typeof en>;
